import { render, staticRenderFns } from "./DiscountsRecord.vue?vue&type=template&id=00ac1953"
import script from "./DiscountsRecord.vue?vue&type=script&lang=js"
export * from "./DiscountsRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports